import React, {PropTypes, Component } from 'react';
import renderHTML from 'react-render-html';
import {getCityBySlug} from "./cities/Cities";;
import CityImage from './CityImage';

const CITY_CREDITS_DATA = [
  [
    "atlanta", [
    "M. Sean Molley",
    "Bryan Leclair",
    "Megan Orr",
    "John Richardson",
    "Brian Schoner",
    "Greg Watson",
    '<a href="http://www.h4wpc.com/">Historic Fourth Ward Park</a>',
    '<a href="http://www.poncecitymarket.com/">Ponce City Market</a>',
    '<a href="http://beltline.org/">The Atlanta Beltline</a>'
  ]
  ],
  [
    "austin", [
    "Mackenzie Day"
  ] ],
  [
    "boston", [
    "Phil Steindel",
    "J. Heléne Andersson",
    "James Burdin",
    "Rachel Burdin",
    "Nathan Curtis",
    "Katie Hamill",
    "Ben Horkley",
    "Ben Smith",
    "Kevin Wald",
    "Lena Webb",
    "Carol Carveth",
    "Joel Fried",
    "Sarah Leadbeater",
    "Marc Asdoorian",
    "Andrea Cendrowski",
    "Madison Schmitt",
    "Elaine Kristant"
  ] ],

  ["chicago", [
    "James Nelson",
    "Evan Jacover",
    "Anna McCleary",
    "Victoria Wang",
    "Wil Zambole"
  ]],
  ["davis", [
    "Paul Rundle"
  ]],
  ["fremont", [
    "Jennifer Chen",
    "Eric Tung",
    "Chris Willmore",
    "Sean Gugler",
    "Harvind Rai",
    "Ruhi Rai",
    "Rebecca Boorsma",
    "Larry Hoskin",
    "<a href='www.fremont.gov'>City of Fremont</a>"]],

  ["london", [
    "Greenie Cheng",
    "Tom Flynn",
    "Jackson Gabbard",
    "Caroline Hardman",
    "Jan Schneider"
  ]],
  ["los-angeles", [
    "Cheryl Gaul",
    "Jean Gaul",
    "Thomas Gaul",
    "John Gaul",
    "Dennis Eichhorn",
    "Dann Webster",
    "AJ Webster",
    "Zach Olauson",
    "Sylwia Olak",
    "Peter Frank"]],
  ["minneapolis", [
    "Mark Larson",
    "Charles Borchert",
    "Marc Gutman",
    "Evan Hall",
    "<a href='http://mn-japan.org'>Japan America Society of Minnesota</a>",
    "<a href='http://keeganspub.com'>Keegan's Irish Pub</a>",
    "<a href='http://riddle-room.com'>Riddle Room</a>",
    "<a href='http://tuggsminneapolis.com'>Tuggs Tavern"]],
  ["new-york", [
    "Kevin Lee",
    "Matt Selsky",
    "Gary Selsky",
    "Simon Shewmaker",
    "Yia Hang",
    "Marina Chen",
    "Myrna Chen",
    "Chris Horng",
    "Haekyung Kim",
    "Jess Li",
    "Caroline Oh",
    "Dean Shu",
    "Albert Wu",
    "Sandra Ho",
  ]],
  ["provo", [
    "Jeremy Dye",
    "Tara Dye",
    "Laura Dye",
    "Greg Dye",
    "Anthony Dye"
  ]],
  ["san-francisco", [
    "Jesse Morris",
    "Justin Graham",
    "Charlie Graham",
    "Greg DeBeer",
    "Rachel Keeler",
    "Linda Holman",
    "Casey Holman",
    "Sandra Murray",
    "Maja Catipovic"
  ]],
  ["seattle", [
    "Melitta Riley",
    "Cathy Saxton",
    "Jonah Ostroff",
    "Kim Salada",
    "Charles Salada",
    "Audrey Chang",
    "Han Beh",
    "Kelsey Bloomquist",
    "Jesse Parsons",
    "Stephan Mueller",
    "Tom Saxton",
    "Kyle Parker-Robinson",
    "Jon Caruana",
    "Christine Caruana"
  ]],
  ["st-louis", [
    "Julie Buchheit-Morrissey",
    "Russell Morrissey",
    "Donna and Joe Buchheit",
    "Nick Buchheit",
    "Kelly Buchheit",
    "Dave Iseman",
    "Emily and Tracey Morrissey",
    "<a href='http://www.escapefromstl.com'>Escape From St. Louis</a> ",
    "<a href='http://www.saratogalanes.com'>Saratoga Lanes</a> ",
    "<a href='http://www.livejukejoint.com'>The Live Juke Joint</a> ",
    "<a href='http://www.fantasyshoponline.com'>The Fantasy Shop Maplewood</a> ",
    "<a href='http://schlafly.com/bottleworks'>Schlafly Bottleworks</a>",
    "<a href='http://www.bookhousestl.com'>The Book House</a>",
    "<a href='http://www.cityofmaplewood.com'>The City of Maplewood</a>"
  ]],
  ["washington", [
    "Steve & Julie Gaddy",
    "Rose & Casey Robinson",
    "Alex & Anji Stinson",
    "Jason Florek",
    "Rex Miller",
    "<a href='http://dcphr.org/'>DC Puzzle Hunters</a>",
    "<a href='https://www.facebook.com/groups/236117913308/'>ASquared Adventures</>",
    "<a href='https://www.facebook.com/groups/464785667038053/'>Frederick Puzzles</>"
  ]],
  ["enschede", [
    "Ronald Meijer",
    "Joris Diesvelt",
    "Steven de Heus",
    "Tim van der Made",
    "<a href='http://utwente.nl'>University of Twente</a>"
  ]]
].reduce(function(map, obj) {
  map[obj[0]] = obj[1];
  return map;
}, {});

class CityCredits extends Component {
  static propTypes = {
    citySlug: PropTypes.string.isRequired,
  };

  render() {
    const citySlug = this.props.citySlug;
    const city = getCityBySlug(citySlug);
    const members = CITY_CREDITS_DATA[citySlug];
    const memberMarkup = members.map((member, index) => this.item(member, index));
    return (
        <div key={`${citySlug}-city-section`} id={citySlug} className="row">
          <article className="col-lg-12 col-md-12 col-sm-12 bookstoreBox">
            <h2><span>{this.props.hideName === true ? '' : `${city.name} `}Game Control</span></h2>
          </article>
          <article className="col-lg-6 col-md-6 col-sm-6 who-box">
            <div className="thumb-pad3">
              <div className="thumbnail">
                <figure><CityImage city={city.name}/></figure>
              </div>
            </div>
          </article>
          <article className="col-lg-6 col-md-6 col-sm-6 who-box">
            <ul className="list6">
              {memberMarkup}
            </ul>
          </article>
        </div>
    );
  }
  item(item, index) {
    const key = `li-key-${index}`;
    return (<li key={key}><strong>{renderHTML(item)}</strong></li>);
  }
}

export default CityCredits;


// WEBPACK FOOTER //
// ./src/CityCredits.js